"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeUndefinedAndDuplicates = void 0;
function removeUndefinedAndDuplicates(list) {
    const listWithoutUndefined = list.filter((item) => item !== undefined);
    return [...new Set(listWithoutUndefined)];
}
exports.removeUndefinedAndDuplicates = removeUndefinedAndDuplicates;
//# sourceMappingURL=removeUndefinedAndDuplicates.js.map